module.exports = __webpack_public_path__ + "img/default-driver.dc94bad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default-driver.png
// module id = hgIn
// module chunks = 1